export function copy(val) {
    return JSON.parse(JSON.stringify(val))
}

export function transOperator(type) {
    let value
    switch (type) {
        case 'add': {
            value = '+'
            break
        }
        case 'multiply': {
            value = 'x'
            break
        }
        case 'minus': {
            value = '-'
            break
        }
        case 'divide': {
            value = '÷'
            break
        }
    }
    return value
}

export function EventHub() {
    //定义一个用来存储回调的对象
    let eventList = {}
    // 事件订阅
    EventHub.prototype.on = function (eventName, callback) {
        //拿到key的值
        let eventCallbacks = eventList[eventName]
        if (eventCallbacks) {
            // 判断是否有注册事件，如果条件成立，说明该事件已经注册过，所以我们可以把函数push进数组中
            eventCallbacks.push(callback)
        } else {
            // 如果没有注册事件以数组的形式存储一份  因为一个事件下面可以注册多个函数
            eventList[eventName] = [callback]
        }
    }
    //事件分发
    EventHub.prototype.emit = function (eventName, data) {
        // 还是拿到key 的值
        let callbacks = eventList[eventName]
        if (callbacks && callbacks.length > 0) {
            // 条件成立之后 通过遍历拿到每个存储的函数
            callbacks.forEach(callback => callback(data))
        }
    }
    // 事件移除
    EventHub.prototype.off = function (eventName) {
        // 如果传入值为空 移除所有监听事件
        if (typeof eventName === 'undefined') {
            eventList = {}
        } else {
            // 移除指定的监听事件
            delete eventList[eventName]
        }
    }
}